<template>
	<div class="KnowledgeServIndex" ref="knowledgeRef">
		<!-- 头部 -->
		<TopHeader ref="myHeader" />
		<!-- banner -->
		<Banner />
		<!-- pc 列表 -->
		<div class="BookContWrap">
			<div class="leftContWrap">
				<div v-if="showLayout" class="indexContWrap">
					<!-- 我的知识服务平台btn -->
					<div class="my-platform-box">
						<a class="my-platform-btn" href="https://www.tunnelling.cn/PMember/mybooklist.aspx" target="_blank">我的知识平台</a>
					</div>
					<!-- 最新知识 -->
					<ItemTitle v-if="NewList && NewList.length > 0" :margin-top="0" title="最新知识" />
					<!-- 目录 -->
					<ul v-if="showLayout" class="PcList">
						<li v-for="(item, index) in NewList" :key="index">
							<!-- 只有节or章 -->
							<div v-if="item.children == null || item.subChapterCount == 0">
								<div :class="item.pageCount > 0 ? 'nodeWrap canHover' : 'nodeWrap'">
									<span class="pc_nodeText" :id="'title' + item.id" v-if="item.pageCount === 0 || item.nodeType === '章'" :title="item.title">{{ item.title }}</span>
									<span class="pc_nodeText"
										:id="'title' + item.id" v-else-if="item.currentPrice === -1 && item.tryReadingPages > 0" :title="item.title" @click="
										OpenTitleRead(item.id, item.purchased, 1, item.informationId, item.firstChapterId)">
										{{ item.title }}
									</span>
									<span class="pc_nodeText"
										:id="'title' + item.id" v-else-if="item.currentPrice != -1 && item.tryReadingPages > 0"
										@click="OpenTitleRead(item.id, item.purchased, null, item.informationId, item.firstChapterId)"
										:title="item.title">
										{{ item.title }}
									</span>
									<span class="pc_nodeText" :id="'title' + item.id" v-else :title="item.title">{{ item.title }}</span>
									<div v-if="item.currentPrice >= 0">
										<div class="PurchasedBtn" v-if="item.purchased && item.isGoods">
											<!-- <div class="chapterPrice" v-if="item.subChapterCount > 1">
												<span>{{'¥'+item.currentPrice}}</span>
												<span class="original" v-if="item.currentPrice != item.originalPrice">{{'¥'+item.originalPrice}}</span>
												<span v-else></span>
											</div> -->
											<span>已购</span>
											<router-link :to="{ path: '/bookRead', query: { InformationId: item.informationId, id: item.id }}"
												target="_blank"
												class="hoverBtn"
												v-if="item.pageCount > 0 && !item.firstChapterId">
												去阅读
											</router-link>
											<router-link :to="{ path: '/bookRead', query: { InformationId: item.informationId, id: item.firstChapterId }}"
												target="_blank"
												class="hoverBtn"
												v-if="item.pageCount > 0 && item.firstChapterId">
												去阅读
											</router-link>
										</div>
										<div class="tryReadBtn" v-else>
											<!-- 某些商品需要手动添加优惠 -->
											<div class="chapterPrice">
												<img src="../assets/img/page_index_sale.png" v-if="item.currentPrice != item.originalPrice" />
												<span class="current">{{ "¥" + item.currentPrice }}</span>
												<span class="original" v-if="item.currentPrice != item.originalPrice">{{ "¥" + item.originalPrice }}</span>
												<span v-else></span>
											</div>
											<span class="tryText"
												v-if="item.tryReadingPages > 0 && item.nodeType !== '章'"
												@click="OpenTryRead(item.id, null, null, item.informationId, item.firstChapterId)">
												试读
											</span>
											<span class="tryText" style="border: 0;" v-else></span>
											<!-- 加入购物车 -->
											<span class="Addbooklist" @click="OpenChapterBuy('cart', item.id, null, item.informationId, item.firstChapterId)">加入书单</span>
											<!-- 直接购买 -->
											<!-- <span class="Addbooklist" style="display: none;" @click="OpenChapterBuy('zj',item.id,null,item.informationId,item.firstChapterId)">加入书单</span> -->
										</div>
									</div>
									<div v-else-if="item.currentPrice === -1">
										<div class="PurchasedBtn" v-if="item.purchased && item.isGoods">
											<router-link :to="{ path: '/bookRead', query: { InformationId: item.informationId, id: item.id }}"
												target="_blank"
												class="hoverBtn"
												v-if="item.pageCount > 0 && !item.firstChapterId">
												去阅读
											</router-link>
											<router-link :to="{path: '/bookRead', query: { InformationId: item.informationId, id: item.firstChapterId }}"
												target="_blank"
												class="hoverBtn"
												v-if="item.pageCount > 0 && item.firstChapterId">
												去阅读
											</router-link>
										</div>
										<div class="tryReadBtn" v-else>
											<span class="tryText"
												v-if="item.tryReadingPages > 0 && item.nodeType !== '章'"
												@click="OpenTryRead(item.id, 1, null, item.informationId, item.firstChapterId)">
												试读
											</span>
											<span class="tryText" style="border: 0;" v-else></span>
											<span style="width: 88px;display: inline-block;"></span>
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
					<!-- 热门推荐 -->
					<HotRecommend />
					<!-- 最新更新 -->
					<ItemTitle title="最新更新" url="/latestUpdates" />
					<ul class="newestList bookListWrap">
						<li v-for="(item, index) in NewestList" :key="index" v-show="item.id !== 35">
							<router-link :to="{ path: '/bookDetail', query: { InformationId: item.id } }" target="_blank">
								<img :src="item.imagePath" alt="" :onerror="defaultImg" />
								<img v-if="item.isNew" class="new" src="../assets/img/new-mark.gif" alt="" />
								<p :title="item.title">{{ item.title }}</p>
							</router-link>
						</li>
					</ul>
					<!-- 查看更多 -->
					<span v-if="isshowMore" class="newest-look-more" @click="LookMore(true)">查看更多</span>
				</div>
				<!-- mobile 列表 -->
				<div class="indexContWrap" v-else>
					<!-- 最新知识 -->
					<div class="myPlatformBox" v-if="NewList && NewList.length > 0">
						<h2>最新知识</h2>
						<a href="javascript: ;" @click="toGoPageFn">我的知识平台</a>
					</div>
					<ul class="mobileList">
						<li v-for="(item, index) in NewList" :key="index">
							<!-- 只有节or章 -->
							<div v-if="item.children == null || item.subChapterCount == 0">
								<div class="nodeWrap">
									<div class="TitlePrice">
										<span v-if="item.nodeType === '章'" class="mobile_nodeText">{{ item.title }}</span>
										<span v-else
											class="mobile_nodeText"
											@click="GoTryRead(item.pageCount, item.purchased, item.id, item.tryReadingPages, item.currentPrice, 1, null, item.informationId, item.firstChapterId)">
											{{ item.title }}
										</span>
									</div>
									<div class="btnWrap_mob">
										<div>
											<a href="javascript:;"
												@click="GoTryRead( item.pageCount, item.purchased, item.id, item.tryReadingPages, item.currentPrice, 1, null, item.informationId, item.firstChapterId)"
												class="mobile_tryread"
												v-if="item.tryReadingPages > 0 && !item.purchased && item.nodeType !== '章'">
											</a>
										</div>
										<div class="btnBox_mob">
											<router-link :to="{ path: '/bookRead', query: { InformationId: item.informationId, id: item.id }}"
												class="mobileAllRead"
												v-if="item.purchased && item.isGoods && item.pageCount > 0">
											</router-link>
											<!-- 加入购物车 -->
											<a href="javascript:;"
												@click="GoPayment('cart', 0, item.id, null, item.informationId, item.firstChapterId)"
												class="mobile_addBooklist"
												v-if="item.currentPrice != -1 && !item.purchased">
											</a>
											<!-- 直接购买 -->
											<!-- <a href="javascript:;" style="display: none;" @click="GoPayment('zj',0,item.id,null,item.informationId,item.firstChapterId)" class="mobile_addBooklist"></a> -->
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
					<!-- 热门推荐 -->
					<div class="myPlatformBox">
						<h2>热门推荐</h2>
						<a href="https://zhishi.tunnelling.cn/#/myBookList" target="_blank" v-if="NewList && NewList.length == 0">我的知识平台</a>
					</div>
					<ul class="hotRecommend bookListWrap">
						<li v-for="(item, index) in HotRecommendList" :key="index">
							<router-link :to="{ path: '/bookDetail', query: { InformationId: item.id } }">
								<div class="bookWrap">
									<img :src="item.imagePath" alt="" :onerror="defaultImg" />
									<span>推荐</span>
								</div>
								<p :title="item.title">{{ item.title }}</p>
							</router-link>
						</li>
					</ul>
					<!-- 最新更新 -->
					<h2>最新更新</h2>
					<ul class="newestList bookListWrap">
						<li v-for="(item, index) in NewestList" :key="index" v-show="item.id !== 35">
							<router-link :to="{ path: '/bookDetail', query: { InformationId: item.id } }">
								<img :src="item.imagePath" alt="" :onerror="defaultImg" />
								<img v-if="item.isNew" class="new" src="../assets/img/new-mark.gif" alt="" />
								<p :title="item.title">{{ item.title }}</p>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="rightContWrap" v-if="showLayout">
				<DetailOther />
			</div>
		</div>
		<!-- 试读 -->
		<div v-if="showTryRead">
			<TryRead
				:fatherId="fatherid"
				:tryReadId="tryReadId"
				:firstChildId="firstchildId"
				:InformationId="InformationId"
				:sellWay="sellway"
				:isIndex="true" />
		</div>
		<!-- 付款弹窗 -->
		<div class="PopupWrap" v-if="showChapterBuy">
			<DownloadChapter
				:downloadWay="downloadWay"
				:chapterId="chapterId"
				:goods="Goods"
				:sellWayText="textTip"
				:iID="InformationId" />
		</div>
		<!-- 加入购物车成功提示 -->
		<div v-if="showAddCartTip">
			<addCartSuccess
				:bookImgUrl="addCartInfo.imagePath"
				:bookTitle="addCartInfo.name"
				:chapterTitle="addCartInfo.informationTitle" />
		</div>
		<!-- 页脚 -->
		<BottomFooter />
		<!-- 在线客服 -->
		<online-service />
	</div>
</template>

<script>
	const ItemTitle = () => import('../components/ItemTitle');
	const addCartSuccess = () => import('../components/addCartSuccess');
	const DetailOther = () => import('../components/DetailOther');
	const TopHeader = () => import('../components/TopHeader');
	const Banner = () => import('../components/Banner');
	const HotRecommend = () => import('../components/HotRecommend');
	const BottomFooter = () => import('../components/BottomFooter');
	const OnlineService = () => import('../components/OnlineService');
	const TryRead = () => import('../components/TryRead');
	const DownloadChapter = () => import('../components/DownloadChapter');
	
	import common from "../assets/js/common.js";

	export default {
		data() {
			return {
				NewList: [],
				NewestList: [], // 最新更新列表
				HotRecommendList: [], // 热门推荐列表
				currentPage: 1, // 当前页
				lookMorePage: 3, // pc端加载更多的当前页 根据pagesize计算的初始值
				lookMorePageSize: 8, // pc端加载更多的条数
				pagesize: 24,
				isshowMore: false, // 是否显示查看更多
				showLayout: true, // 移动or pc 布局
				showTryRead: false, // 试读
				showChapterBuy: false, // 章节下载
				downloadWay: 0, // 下载方式 0：章节下载 1：全书购买
				InformationId: undefined, // 情报id
				sellway: undefined, // 购买方式
				tryReadId: undefined, // 试读id
				tryTitle: "", // 试读标题
				tryReadPage: 1, // 试读页数
				Goods: {}, // 商品
				chapterId: undefined, // 章节id
				fatherid: undefined, // 试读的章id
				firstchildId: undefined, // 章的第一个节id
				textTip: undefined, // 试读里售卖方式
				showAddCartTip: false, // 加入购物车成功提示的显隐
				addCartInfo: {}, // 加入购物车的信息
				defaultImg: 'this.src="' + require("../assets/img/default_pic.png") + '"', // 默认封面
				discountBooks: [{
						id: 3316,
						originalPrice: 9.6
					},
					{
						id: 3312,
						originalPrice: 6.4
					},
					{
						id: 3174,
						originalPrice: 8.8
					},
					{
						id: 3116,
						originalPrice: 8
					}
				], // 需要显示优惠icon价格的书
				wrapDom: null // 外层容器
			};
		},
		mounted() {
			// 判断加载哪个dom
			let wid = window.innerWidth;
			if (wid >= 320 && wid <= 1024) {
				this.showLayout = false;
				this.GetHotRecommend();
				this.$nextTick(() => {
					this.handleScrollFn();
				});
			}
			
			// 首页访问记录统计
			this.accessRecordFn();
			// 获取最新知识
			this.GetNewBook();
			// 是否出现弹窗
			this.ShowPopupFn();
			// 获取最新更新
			this.GetNewest();

			// 触发关闭章节购买事件车
			common.$on("closeChapter", () => {
				this.showChapterBuy = false;
			});
			// 关闭试读
			common.$on("closeRead", () => {
				this.showTryRead = false;
			});
			// 关闭加入购物车成功的提示
			common.$on("closeTip", () => {
				this.showAddCartTip = false;
			});
			// 支付事件车
			this.BuyBookWay();
		},
		methods: {
			// 滚动加载事件
			handleScrollFn() {
				this.wrapDom = this.$refs.knowledgeRef;
				this.wrapDom.addEventListener('scroll', () => {
					// 滚动距离
					const scrollTop = this.wrapDom.scrollTop
					// 变量windowHeight是可视区的高度
					const windowHeight = this.wrapDom.clientHeight
					// 变量scrollHeight是滚动条的总高度
					const scrollHeight = this.wrapDom.scrollHeight
					if (scrollTop + windowHeight + 20 > scrollHeight && this.isshowMore) {
						//防止重复请求数据
						this.isshowMore = false
						// 获取到的不是全部数据 当滚动到底部 继续获取新的数据
						this.LookMore()
					}
				}, true)
			},
			// 是否出现弹窗
			ShowPopupFn() {
				let isshow = this.$route.query.isPopup;
				if (isshow != "true") return;

				this.InformationId = this.$route.query.InformationId;
				this.tryReadId = this.$route.query.tryReadId - 0;
				this.sellway = this.$route.query.sellWay == "null" ? undefined : this.$route.query.sellWay - 0;
				if (this.sellway == 0) {
					this.fatherid = this.$route.query.fatherId - 0;
					this.firstchildId = this.$route.query.firstChildId - 0;
				}
				let url = `/api/information/${this.InformationId}/informationContent/${this.tryReadId}`;

				this.$fetch(url).then(res => {
					if (res.data.purchased) {
						this.$confirm(
							"您刚才选择试读的是已购内容，可直接去阅读。",
							"提示", {
								confirmButtonText: "确定",
								cancelButtonText: "取消",
								type: "warning"
							}
						).then(() => {
							this.$router.push({
								path: "/bookRead",
								query: {
									InformationId: this.InformationId,
									id: this.tryReadId
								}
							});
						}).catch(() => {});
						return;
					}
					this.showTryRead = true;
				}).catch(err => {
					throw err;
				});
			},
			// 跳转页面
			toGoPageFn() {
				let isLogin = this.$refs.myHeader.getIsLoginVal();
				
				if (isLogin) {
					this.$router.push("/myBookList");
					return;
				}

				let nowHref = location.href;
				let href = "https://m.tunnelling.cn/Manager/Login.aspx?returnUrl=" + encodeURIComponent(nowHref);
				location.href = href;
			},
			// 首页访问记录
			accessRecordFn() {
				this.$post("/api/PageAccessRecord/homePageViews").then(res => {
					
				}).catch(err => {
					throw err;
				});
			},
			// 获取最新更新
			GetNewest() {
				let params = `?PageNumber=${this.currentPage}&PageSize=${this.pagesize}&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc`;
				let nowDate = this.getDateFn();
				let data = 0, createionDate = "";
				this.$fetch("/api/information" + params)
					.then(res => {
						// 大于小于两个月(60天)的书显示new标志
						for (let i = 0; i < res.data.length; i++) {
							createionDate = res.data[i].creationDate.split(" ")[0];
							data = this.getDaysBetween(createionDate, nowDate);
							res.data[i].isNew = data <= 60 ? true : false;
						}
						this.NewestList = this.NewestList.concat(res.data);
						let headers_info = JSON.parse(res.headers["x-pagination"]);
						let total = headers_info.totalCount;
						// 是否显示加载更多
						if (total === this.NewestList.length) {
							this.isshowMore = false;
						} else {
							this.isshowMore = true;
						}
					}).catch(err => {
						throw err;
					});
			},
			// 获取热门推荐
			GetHotRecommend() {
				let params = "?PageNumber=1&PageSize=5&IsRecommend=true&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc";
				this.$fetch("/api/information" + params)
					.then(res => {
						this.HotRecommendList = res.data;
					})
					.catch(err => {
						throw err;
					});
			},
			//获取最新知识
			GetNewBook() {
				this.$fetch("/api/TopChapters").then(res => {
					// 某些商品需要手动添加优惠
					for (let i = 0; i < this.discountBooks.length; i++) {
						for (let j = 0; j < res.data.length; j++) {
							if (this.discountBooks[i].id == res.data[j].id) {
								res.data[j].originalPrice = this.discountBooks[i].originalPrice;
								break;
							}
						}
					}

					this.NewList = res.data;
				});
			},
			// 判断两个日期相差多少天
			getDaysBetween(dateString1, dateString2) {
				var startDate = Date.parse(dateString1);
				var endDate = Date.parse(dateString2);
				if (startDate > endDate) {
					return 0;
				}
				if (startDate == endDate) {
					return 1;
				}
				var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
				return days;
			},
			// 获取当前时间的年月日
			getDateFn() {
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				if (month < 10) {
					month = "0" + month;
				}
				if (day < 10) {
					day = "0" + day;
				}
				return year + "-" + month + "-" + day;
			},
			// 查看更多
			LookMore(isPCLookMore = false) {
				// pc端加载更多 每次只加载两行 8 条数据
				if(isPCLookMore) {
					this.lookMorePage ++;
					this.currentPage = this.lookMorePage;
					this.pagesize = this.lookMorePageSize;
				}else {
					this.currentPage ++;
				}
				this.GetNewest();
			},
			// 去试读-mobile
			GoTryRead(
				pagecount,
				ispurchased,
				id,
				tryReadPage,
				issell,
				type,
				index,
				InformationId,
				firstChapterId
			) {
				this.firstchildId = firstChapterId;
				this.InformationId = InformationId;
				if (pagecount === 0) return;
				if (ispurchased) {
					this.$router.push({
						path: "/bookRead",
						query: {
							id: firstChapterId ? firstChapterId : id,
							InformationId: this.InformationId
						}
					});
					return;
				}
				if (tryReadPage === 0) return;
				if (type == 1) {
					this.$router.push({
						path: "/bookTryRead",
						query: {
							id: firstChapterId ? firstChapterId : id,
							InformationId: this.InformationId,
							sellway: type,
							isIndex: true
						}
					});
					return;
				}
				let arr = this.NewList[index];
				this.$router.push({
					path: "/bookTryRead",
					query: {
						id: firstChapterId ? firstChapterId : id,
						fatherId: arr.id,
						// firstchildId: arr.children[0].id,
						firstchildId: this.firstchildId,
						InformationId: this.InformationId,
						sellway: type,
						isIndex: true
					}
				});
			},
			// 点击标题 进入阅读or试读
			OpenTitleRead(id, purchased, type, InformationId, firstChapterId) {
				// firstChapterId为true 代表是章
				if (firstChapterId) {
					this.firstchildId = firstChapterId;
					this.fatherid = id;
				}
				this.tryReadId = firstChapterId ? firstChapterId : id;
				this.InformationId = InformationId;

				if (purchased) {
					this.$router.push({
						path: "/bookRead",
						query: {
							InformationId: this.InformationId,
							id: firstChapterId ? firstChapterId : id
						}
					});
				} else {
					this.showTryRead = true;
					this.sellway = type;
					// this.OpenTryRead(id, type, null, InformationId, firstChapterId);
				}
			},
			// 打开试读-pc  价格为-1时，需要把章id以及章的第一节id传过去
			OpenTryRead(id, type, index, informationId, firstChapterId) {
				if (firstChapterId) {
					this.firstchildId = firstChapterId;
					this.fatherid = id;
				}
				this.InformationId = informationId;
				this.tryReadId = firstChapterId ? firstChapterId : id;
				this.showTryRead = true;
				this.sellway = type;
				if (type == 0) {
					// let arr = this.NewList[index];
					this.fatherid = id;
					this.firstchildId = firstchildId;
					// firstchildId = this.firstchildId
				}
			},
			// 判断是否登录
			LoginTipFn() {
				this.$confirm("此操作需登录后进行，是否继续？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						let nowHref = location.href;
						let href =
							"https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=" +
							encodeURIComponent(nowHref);
						location.href = href;
					})
					.catch(() => {});
			},
			// 去支付--mobile childrenId:为整章购买的第一节id
			GoPayment(isCart, type, id, childrenId, InformationId, firstChapterId) {
				this.firstchildId = firstChapterId;
				this.InformationId = InformationId;
				this.$fetch("/Login")
					.then(res => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}

						// 加入购物车
						if (isCart === "cart") {
							this.GetSingleGoods("cart", id, firstChapterId);
							return;
						}

						// *直接购买方式-打开购买弹窗（暂时弃用）
						this.$router.push({
							name: "BookPayment",
							query: {
								type: type,
								InformationId: this.InformationId,
								id: id,
								chapterId: childrenId ? childrenId : id
							}
						});
					})
					.catch(err => {
						throw err;
					});
			},
			// 打开章节购买-获取情报里的内容商品  chapterId:为整章购买的第一节id isgoods:是否是商品 isCart:值为cart加入购物车方式
			OpenChapterBuy(isCart, id, chapterId, InformationId, firstChapterId) {
				this.firstchildId = firstChapterId;
				this.InformationId = InformationId;
				this.$fetch("/Login")
					.then(res => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}

						this.GetSingleGoods(isCart, id, chapterId);
					})
					.catch(err => {
						throw err;
					});
			},
			// 加入购物车
			addToCartFn(goodsId) {
				this.$post("/api/ShoppingCarts", {
						goodsId: goodsId
					})
					.then(res => {
						// 获取购物车数量
						this.getCartCountFn();
						// 提示
						this.showAddCartTip = true;
					})
					.catch(err => {
						this.$message({
							message: err.response.data,
							type: "error",
							offset: 100
						});
					});
			},
			// 获取购物车数量
			getCartCountFn() {
				common.$emit("getCartNum");
			},
			// 支付方式
			BuyBookWay() {
				common.$on("buyBook", (isCart, type, issell, chapterId, firstchildId) => {
					this.textTip = issell;
					if (issell === -1) {
						this.$confirm(
								"您选择试读的文章无法单独加入书单，所以将选择其所在章（书）加入，是否继续？",
								"提示", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning"
								}
							)
							.then(() => {
								if (type == 0) {
									this.GetSingleGoods(isCart, chapterId, firstchildId);
								} else if (type == 1) {
									this.GetGoods(isCart);
								}
							})
							.catch(() => {});
					} else {
						if (type == 0) {
							this.GetSingleGoods(isCart, chapterId, firstchildId);
						} else if (type == 1) {
							this.GetGoods(isCart);
						}
					}
				});
			},
			// 获取单个商品
			GetSingleGoods(isCart, id, chapterId) {
				this.downloadWay = 0;
				this.chapterId = chapterId ? chapterId : id;
				this.$fetch(
						"/api/information/" +
						this.InformationId +
						"/informationContent/goods/?id=" +
						id
					)
					.then(res => {
						if (isCart === "cart") {
							this.addCartInfo = res.data;
							this.addToCartFn(res.data.id);
							return;
						}

						// *直接购买方式-打开购买弹窗（暂时弃用）
						this.Goods = res.data;
						this.showChapterBuy = true;
					})
					.catch(err => {
						throw err;
					});
			},
			// 获取整个情报商品
			GetGoods(isCart) {
				this.$fetch("/Login")
					.then(res => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}

						this.downloadWay = 1;
						this.chapterId = sessionStorage.getItem("firstPurchasedId");
						this.$fetch("/api/information/goods/?id=" + this.InformationId)
							.then(res => {
								// 加入购物车
								if (isCart === "cart") {
									this.addCartInfo = res.data;
									this.addToCartFn(res.data.id);
									return;
								}

								// *直接购买 （暂时弃用）
								this.Goods = res.data;
								this.showChapterBuy = true;
							})
							.catch(err => {
								throw err;
							});
					})
					.catch(err => {
						throw err;
					});
			}
		},
		components: {
			ItemTitle,
			TopHeader,
			DetailOther,
			Banner,
			HotRecommend,
			BottomFooter,
			OnlineService,
			DownloadChapter,
			TryRead,
			addCartSuccess
		}
	};
</script>

<style scoped>
	@import './home.css';
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue